import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DisplayErrorsMessageComponent } from './display-errors-message.component';

@NgModule({
  declarations: [DisplayErrorsMessageComponent],
  imports: [CommonModule, TranslatePipe, TranslateDirective],
  exports: [DisplayErrorsMessageComponent],
})
export class DisplayErrorsMessageModule {}
